



























































import 'firebase/firestore'
import Ping from 'ping.js'

db = null
unsubscribe = null

get = (url) ->
  req = new XMLHttpRequest()
  req.open('GET', url, true)
  p = new Promise (ok, err) ->
    req.onreadystatechange = ->
      if req.readyState is 4
        if req.status is 200 then ok(req.responseText) else err("Error: #{ req.status } while loading #{ url }")
  req.send(null)
  p

do -> window.geo ?= JSON.parse(await get 'https://geolocation.redka.workers.dev')

ping = new Ping

export default
  name: 'ServerList'

  props: ['game']

  data: ->
    currentRegion: null
    regions: []
    servers: []
    isEmpty: false
    serverPingTimeouts: {}
    dividedByRegion: @game in ['shootout', 'mages']
    inIframe: frameElement? or window.location isnt window.parent.location

  computed:
    sortedServers: ->
      @servers.filter((s) -> not s.offline).slice(0).sort (a, b) -> (a.ping ? 999) - (b.ping ? 999)

  watch:
    currentRegion: -> @getServers(@currentRegion) if @dividedByRegion
    game: -> @getServers(@currentRegion) if @game?

  created: ->
    window.list = this
    db = (await _when -> window.firebase).firestore()
    @getServers() if not @dividedByRegion
    myRegionCode = (await _when -> window.geo).country.continent
    (await db.collection('regions').get()).forEach (doc) =>
      region = doc.data()
      @regions.push(region)
      @currentRegion = region if region.supported_regions.includes(myRegionCode)

  destroyed: ->
    unsubscribe?()
    @clearPingTimeouts()

  methods:
    clearPingTimeouts: ->
      clearTimeout timeout for _, timeout of @serverPingTimeouts
      @serverPingTimeouts = {}

    getServers: (region) ->
      unsubscribe?()
      @servers = []
      @isEmpty = false
      @clearPingTimeouts()
      ref = db.collection('servers').where('game', '==', @game)
      ref = ref.where('region', '==', region.code) if @dividedByRegion
      unsubscribe = ref.onSnapshot (snapshot) =>
        snapshot.docChanges().forEach ({ type, doc }) =>
          id = doc.id
          switch type
            when 'added'
              server = Object.assign(doc.data(), { id, ping: null })
              server.vpsUrl = "https://#{ server.vps }.redka.games"
              server.url = "https://#{ @game }.redka.games/#{ server.vps }:#{ server.port }"
              @servers.push(server)
              @reportPing(server)
            when 'modified' then _with @servers.whereFirst({ id }), -> @[prop] = val for prop, val of doc.data()
            when 'removed' then _with @servers.whereFirst({ id }), (s) => @servers.splice(@servers.indexOf(s), 1)
        @isEmpty = @sortedServers.length is 0

    reportPing: ({ vps, vpsUrl }) ->
      return if @serverPingTimeouts[vps]?
      ms = 1000
      maxTooHighCount = 2
      @serverPingTimeouts[vps] = setTimeout fn = =>
        ms = Math.min(ms + 500, 10000)
        ping.ping vpsUrl, (_, data) =>
          if data < 300 or --maxTooHighCount < 0
            pingClass = data < 100 and 'text-greenest' or (data < 150 and 'text-green' or data < 200 and 'text-orange' or 'text-red')
            @servers.where({ vps }).forEach (s) ->
              s.ping = data
              s.pingClass = pingClass
          @serverPingTimeouts[vps] = setTimeout fn, ms
      , ms

